import { ButtonColor } from "@/common/enum/button-color";
import { AdminItemPath } from "@/common/enum/path";
import { Breadcrumb, Button } from "flowbite-react";
import { Link } from "react-router-dom";
import { H4 } from "../typography/H4";

export default function PackageItemMainHeader() {
  return (
    <div className="flex flex-col">
      <Breadcrumb>
        <Breadcrumb.Item>상품 관리</Breadcrumb.Item>
        <Breadcrumb.Item>패키지 상품 관리</Breadcrumb.Item>
      </Breadcrumb>
      <div className="flex items-center justify-between mb-[16px]">
        <div className="mt-[15px] mb-[7px]">
          <H4 className="text-semantic-text-heading">패키지 상품 관리</H4>
        </div>
        <Link to={AdminItemPath.PACKAGE_PRODUCT_CREATE} className="mt-[8px]">
          <Button color={ButtonColor.PRIMARY}>상품 등록</Button>
        </Link>
      </div>
    </div>
  );
}
